<template>
  <PageContainer id="diet-selection-2">
    <div class="page-content no-button">
      <div class="title animated">Do you sometimes have trouble sticking with your diet?</div>

      <ButtonValue :isActive="this.selection === this.text1" :onClick="updateSelection" :text="this.text1" v-bind:value="this.text1"
        :class="this.skipOptionValues.includes(this.text1) ? 'isSkipOption' : ''"/>
      <ButtonValue :isActive="this.selection === this.text2" :onClick="updateSelection" :text="this.text2" v-bind:value="this.text2"
        :class="this.skipOptionValues.includes(this.text2) ? 'isSkipOption' : ''"/>
      <ButtonValue :isActive="this.selection === this.text3" :onClick="updateSelection" :text="this.text3" v-bind:value="this.text3"
        :class="this.skipOptionValues.includes(this.text3) ? 'isSkipOption' : ''"/>
      <ButtonValue :isActive="this.selection === this.text4" :onClick="updateSelection" :text="this.text4" v-bind:value="this.text4"
        :class="this.skipOptionValues.includes(this.text4) ? 'isSkipOption' : ''"/>
    </div>

    <div class="footer-container">
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonValue from '../../shared/components/ButtonValue';
import ProgressBar from '../../shared/components/ProgressBar';
import { delayedTransition, ROUTE_NAMES } from '../router';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { getPrpFlowVersion } from '../../shared/utils';
import { PRP_FLOW_V2 as PrpFlowV2 } from '../../shared/constants';

export default {
  components: {
    PageContainer,
    ButtonValue,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    const questionOptions = this.$store.getters.getOptions('dietSelection2');
    const optLen = questionOptions.length;
    return {
      selection: null,
      skipOptionValues: questionOptions.map(o => { if (o.isSkipOption) { return o.answer_text } }).filter(o => o) || [],
      text1: optLen > 0 ? questionOptions[0].answer_text : 'Yes',
      text2: optLen > 1 ? questionOptions[1].answer_text : 'No, but then I tend to regain the weight',
      text3: optLen > 2 ? questionOptions[2].answer_text : 'I\'m pretty confident in my ability to stick with it',
      text4: optLen > 3 ? questionOptions[3].answer_text : 'I\'ve never really tried to lose weight before'
    }
  },
  methods: {
    updateSelection(event) {
      this.selection = event.currentTarget.value
      this.$store.commit('updateAnswers', { dietSelection2: this.selection });
      const originalPath = this.skipOptionValues.includes(this.selection) ? ROUTE_NAMES.PaidOut : ROUTE_NAMES.NextSteps;
      const path = getPrpFlowVersion() === PrpFlowV2 ? ROUTE_NAMES.Calculating : originalPath;
      delayedTransition(this.$router, path)
    }
  }
}
</script>
